module.exports = __webpack_public_path__ + "img/superhero.88ceba4f.png";